export const CO_PARENT_INVITATION_STORAGE_KEY = 'co_parent_invitation';

export const CO_PARENT_QUERY_PARAMS = {
  INVITER_NAME: 'inviter_name',
  INVITE_NAME: 'invite_name',
  KIDS: 'kids',
  EMAIL: 'email',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  PHONE: 'phone',
} as const;

export const CO_PARENT_SIGN_UP_PATH = '/authentication/sign-up?role=parent';

export const CO_PARENT_IMAGES = {
  INVITATION_ILLUSTRATION: {
    src: '/assets/images/etc/coparentPlane.webp',
    alt: 'Co-parenting invitation',
  },
} as const;
